const sessionValueGetter = (params) => params.data.session_nom;

export default sessionValueGetter;